import { formatComptableMaisPasTrop } from "../../services/function";
import { useInvoiceStore } from "../../stores/invoice";

const Totals = ({ data }: { data: any }) => {
  const {tabInvoice} = useInvoiceStore();
  const total = data?.reduce((acc: number, item: any) => acc + parseFloat(tabInvoice === "Avoirs" ? item.totalAmount : item.amountExclVAT || 0), 0);

  return (
    <div className="flex shrink-0 items-center justify-end gap-3 border-t border-slate-200 bg-slate-50/70 px-4 py-3 font-Nunito sm:px-5">
      <span className="text-[11px] font-bold tracking-wider text-slate-400 uppercase">
        Total
      </span>
      <span className="text-base font-bold text-slate-900 tabular-nums">
        {formatComptableMaisPasTrop(total)}
        <span className="ml-1 text-xs font-semibold text-slate-500">
          {tabInvoice === "Avoirs" ? "TTC" : "HT"}
        </span>
      </span>
    </div>
  )
}

export default Totals
